import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import UpdateListingInfo from '../../components/Proposal/UpdateListingInfo'
import { PROPOSAL_TYPE_NAME } from '../../constants/proposalTypes'

UpdateListingInfo.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const proposalType = PROPOSAL_TYPE.UPDATE_LISTING

const props = {
  proposalType,
  proposalTypeName: PROPOSAL_TYPE_NAME[proposalType]
}

const UpdateListingInfoContainer = WithProposalContainer(UpdateListingInfo, props)

export default UpdateListingInfoContainer
